"use client";

import { usePostHog } from "posthog-js/react";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { logout } from "@/app/actions";
import { cn } from "@/lib/utils";
export function LogoutButton({
  className
}: {
  className?: string;
}) {
  const posthog = usePostHog();
  async function handleLogout(): Promise<void> {
    try {
      const {
        error: error_0
      } = await logout();
      if (error_0) throw error_0;
      posthog?.reset();
      // A full page load, not router.replace: the client router can still
      // hold what it learned while signed in (a /login that sends visitors to
      // /home), and a soft navigation bounced hosts from "Log ind" to /home
      // and on to the homepage.
      window.location.assign("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  }
  return <Button type="button" variant="outline" onClick={() => void handleLogout()} className={cn("flex justify-center gap-2", className)}>
      <LogOut className="h-4 w-4" /> Logout
    </Button>;
}